<template>
	<v-app>
		<v-content :class="{ 'pa-0' : $route.name === 'login' }">
			<v-progress-linear
				class="progress-bar"
				v-bind:indeterminate="isLoading"
				v-if="isLoading">
			</v-progress-linear>
			<router-view></router-view>
		</v-content>
		<v-snackbar :timeout="snackbar.timeout" :color="snackbar.color"
			:top="true" :right="true" v-model="snackbar.isVisible">
			{{ snackbar.text }}
			<v-btn flat @click.native="snackbar.isVisible = false">Cerrar</v-btn>
		</v-snackbar>
	</v-app>
</template>

<script>

function created() {
	this.onToggleSnackBar();
	this.$bus.$on('is-loading', (result) => {
		this.isLoading = result;
	});
}

function data() {
	return {
		isLoading: false,
	};
}

export default {
	name: 'app',
	created,
	data,
};
</script>

<style lang="scss">
html {
	font-family: font(lato) !important;
	font-size: size(medium);
	font-weight: weight(regular);
	scroll-behavior: smooth;
}

.application {
	font-family: font(lato) !important;
}

.theme--light {
	.switch-display {
		&.switch {
			.input-group--selection-controls__ripple--active:after {
				background-color: color(primary) !important;
			}
		}
	}
}

.application .theme--light {
	.switch-display {
		&.switch {
			.input-group--selection-controls__ripple--active:after {
				background-color: color(primary) !important;
			}
		}
	}
}

.switch-display {
	&.input-group {
		&.input-group--selection-controls {
			&.switch {
				.input-group--selection-controls__toggle {
					background-color: rgba(2, 151, 155, 0.13) !important;
					border-radius: 14.5px !important;
					height: 29px !important;
					opacity: 1 !important;
					transform: translate(-29%, -50%) scale(1) !important;
					width: 87px !important;

					&:after {
						content: 'view_list';
						right: 15px;
					}

					&:before {
						content: 'location_on';
						left: 15px;
					}

					&:after, &:before {
						bottom: 0;
						color: color(primary);
						font-family: 'Material Icons';
						font-size: size(medium19);
						line-height: 29px;
						margin: auto;
						position: absolute;
						text-align: center;
						top: 0;
					}
				}

				.input-group--selection-controls__ripple {
					height: 29px !important;
					transform: translate(-20px, -15px);
					width: 43px !important;

					&:after {
						background-color: color(primary) !important;
						content: 'location_on';
					}

					&:after, &:before {
						border-radius: 14.5px !important;
						color: color(white);
						font-family: 'Material Icons';
						font-size: size(medium19);
						height: 29px !important;
						line-height: 29px;
						text-align: center;
						transform: translate(-59%, -50%) scale(1) !important;
						width: 43px !important;
					}

					&--active {
						transform: translate(20px, -15px) !important;

						&:after {
							color: color(white);
							content: 'view_list';
						}
					}
				}
			}
		}
	}
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

img {
	vertical-align: middle;
}

.content {
	background: white;

	&--wrap {
		background-color: color(white);
		padding: 0px;
	}
}

.progress-bar {
	left: 0px !important;
	margin: 0px !important;
	position: absolute !important;
	right: 0px !important;
	top: 120px !important;

	@media (min-width: 600px) {
		top: 80px !important;
	}
}


button {
	min-width: 5px;
	outline: none;

	.table-icon {
		outline: none;
	}
}

.input-group--hide-details {
	.input-group__details {
		display: none;
	}
}

button:disabled {
	cursor: not-allowed;
	opacity: 0.6;
}

.text-uppercase {
	text-transform: uppercase;
}

.btn-auto {
	height: auto !important;
	min-width: auto !important;
	width: auto !important;
}

.btn-full {
	height: auto;
	min-width: auto !important;
	width: 100% !important;
}

.br-desktop {
	@media (max-width: 936px) {
		display: none;
	}
}

.br-mobile {
	@media (min-width: 936px) {
		display: none;
	}
}


.section-media {
	.vue-video-player {
		margin-top: 18px;
	}

	.slider {
		height: 100% !important;
	}

	.slider-icon {
		border-bottom: 4px solid rgba(255,255,255,1) !important;
		border-left: 4px solid rgba(255,255,255,1) !important;
		height: 25px !important;
		width: 25px !important;
	}

	.slider-icon-left {
		left: 4px !important;
		position: relative !important;
		top: 2px !important;
	}

	.slider-icon-right {
		position: relative !important;
		right: 5px !important;
		top: 2px !important;
	}

	.section-slider-slides {
		height: 779px !important;
		margin: auto;
		overflow: hidden !important;
		width: 95% !important;
	}

	.slider-btn-right, .slider-btn-left {
		background-color: map-get($colors, warning) !important;
		border-radius: 50% !important;
		height: 62px !important;
		top: auto !important;
		width: 62px !important;

		@media (max-width: 860px) {
			top: 50%;
		}
	}

	.slider-btn-left {
		left: 0 !important;

		@media (max-width: 860px) {
			top: 72% !important; 	
		}

		@media (min-width: 1024px) {
			left: 5px !important;
		}
	}

	.slider-btn-right {
		right: 0 !important;

		@media (max-width: 860px) {
			top: 72% !important; 	
		}

		@media (min-width: 1024px) {
			right: 5px !important;
		}
	}

	.slider-indicators-center {
		display: none !important;
	}
}

.section-slider {
	.section-slider-slides {
		height: 779px !important;
		margin: auto;
		overflow: hidden !important;
		width: 95% !important;

		@media (min-width: 1024px) {
			height: 725px !important;
			overflow: initial !important;
			width: 80% !important;
		}
	}

	.slider-btn-right, .slider-btn-left {
		background: color(title-green) !important;
		bottom: 95px !important;
		height: 58px;
		margin: auto;
		top: auto !important;
		width: 58px;

		@media (min-width: 1024px) {
			bottom: 0px !important;
			margin: auto;
			top: 0px !important;
		}
	}

	.slider-btn-left {
		left: 30% !important;

		@media (min-width: 600px) {
			left: 40% !important;
		}

		@media (min-width: 1024px) {
			left: -29px !important;
		}
	}

	.slider-btn-right {
		right: 30% !important;

		@media (min-width: 600px) {
			right: 40% !important;
		}

		@media (min-width: 1024px) {
			right: -29px !important;
		}
	}

	.slider-icon {
		border-left: 3px solid color(white) !important;
		border-bottom: 3px solid color(white) !important;
		height: 20px !important;
		margin-top: 6px;
		width: 20px !important;

		&-left {
			margin-left: 6px;
		}

		&-right {
			margin-right: 6px;
		}
	}

	.slider-indicator-icon {
		background: transparent !important;
		border: 1px solid color(success) !important;
		border-radius: 9px !important;
		height: 15px !important;
		width: 46px !important;
	}

	.slider-indicator-active {
		background: color(success) !important;
	}

	.slider-indicators-center {
		@media (max-width: 936px) {
			display: none !important;
		}
	}

	.slider-btn {
		background: color(title-green) !important;
		border-radius: 50%;
		height: 58px !important;
		width: 58px !important;
	}
}

.paragraph {
	font-size: size(medium16);

	@media (min-width: 936px) {
		font-size: size(medium19);
	}

	&-medium {
		@media (min-width: 936px) {
			font-size: size(medium16);
		}
	}
}

.w-black {
	font-weight: weight(black);
}

.w-semibold {
	font-weight: weight(semibold);
}

.w-medium {
	font-weight: weight(medium);
}

.w-bold {
	font-weight: weight(bold);
}

.w-heavy {
	font-weight: weight(heavy);
}

.action-button {
	.btn__content {
		font-family: font(lato) !important;
		font-size: size(medium18) !important;
		font-weight: weight(black) !important;
		padding: 0px !important;
		text-transform: none !important;
	}
}

.app-form-component {
	&.input-group--text-field {
		label {
			color: color(info) !important;
			font-family: font(lato) !important;
			font-size: size(medium16) !important;
			left: 0px;
		}
	}

	&.input-group {
		input {
			color: color(warning) !important;
			font-size: size(medium16) !important;
			font-weight: weight(semibold) !important;
		}

		.input-group__input {
			.input-group__append-icon:not(:hover) {
				color: color(info) !important;
			}
		}

		&.input-group--focused .input-group__input .input-group__append-icon {
			color: inherit !important;
		}

		&.input-group--dirty .input-group__selections__comma:not(.input-group__selections__comma--active) {
			color: color(warning) !important;
			font-size: size(medium16) !important;
			font-weight: weight(semibold) !important;
		}
	}
}

.form-step-three {
	.app-form-component {
		&.input-group {
			input {
				color: white !important;		
			}
		}
	}

	.app-form-component.input-group--text-field label {
		color: white !important;
	}
}

.title-section {
	font-family: font(lato);
	font-size: size(large25);
	margin: 10px 0px;

	@media (min-width: 936px) {
		font-size: size(big);
	}
}

.subtitle-section {
	font-family: font(lato);
	font-size: size(medium16);

	@media (min-width: 936px) {
		font-size: size(large);
	}

	&.small {
		@media (min-width: 936px) {
			font-size: size(medium18);
		}
	}
}

.question-text {
	font-family: font(lato);
	font-size: size(medium);

	@media (min-width: 936px) {
		font-size: size(large);
	}
}

.href-depressed {
	text-decoration: none !important;
}

.app-slider-items {
	.slider-items {
		background: transparent !important;
	}

	.slider-btn {
		background: color(success) !important;
		border-radius: 100%;
		bottom: 0px !important;
		height: 67px !important;
		top: auto !important;
		width: 67px !important;

		@media (min-width: 936px) {
			display: none !important;
		}

		.slider-icon {
			border-bottom: 6px solid color(white);
			border-left: 6px solid color(white);
			border-radius: 5px;
			height: 27px;
			margin-top: 7px;
			width: 27px;

			&.slider-icon-left {
				margin-left: 8px;
			}

			&.slider-icon-right {
				margin-right: 8px;
			}
		}

		&.slider-btn-left {
			left: calc(23vw - 33px);

			@media (min-width: 375px) {
				left: calc(26vw - 33px);
			}

			@media (min-width: 425px) {
				left: calc(30vw - 33px);
			}

			@media (min-width: 600px) {
				left: calc(35vw - 33px);
			}
		}

		&.slider-btn-right {
			right: calc(23vw - 33px);

			@media (min-width: 375px) {
				right: calc(26vw - 33px);
			}

			@media (min-width: 425px) {
				right: calc(30vw - 33px);
			}

			@media (min-width: 600px) {
				right: calc(35vw - 33px);
			}
		}
	}


	.slider-indicators {
		display: none !important;

		@media (min-width: 936px) {
			bottom: 0px !important;
			display: initial !important;
			height: 17px !important;
		}
	}

	.slider-indicator-icon {
		background-color: transparent !important;
		border: 1px solid color(primary) !important;
		border-radius: 9.5px !important;
		height: 15px !important;
		margin: 0px 5.5px !important;
		width: 46px !important;

		&.slider-indicator-active {
			background-color: color(primary) !important;
		}
	}
}

.container {
	margin: 0 auto;
	max-width: 1200px !important;
}

.input-searcher {
	border-radius: 19px;
	height: 38px;

	&.color-white {
		border: 1px solid color(newborder);

		input {
			color: color(white) !important;
			padding-left: 28px;
		}

		.input-group__prepend-icon {
			color: color(white) !important;
		}

		input::-webkit-input-placeholder {
			color: color(white) !important;
		}

		input:-ms-input-placeholder {
			color: color(white) !important;
		}

		input::-moz-placeholder {
			color: color(white) !important;
		}
	}

	&.color-newprimary {
		border: 1px solid rgba(255, 110, 28, 0.36);
		padding-left: 16px;

		input {
			color: color(newprimary) !important;
		}

		.input-group__prepend-icon {
			color: color(newprimary) !important;
		}

		input::-webkit-input-placeholder {
			color: color(newprimary) !important;
		}

		input:-ms-input-placeholder {
			color: color(newprimary) !important;
		}

		input::-moz-placeholder {
			color: color(newprimary) !important;
		}
	}

	input {
		background-color: rgba(255, 255, 255, 0.09);
		border-radius: 19px;
		font-size: size(small);
		height: 38px;
	}

	input::-webkit-input-placeholder {
		font-size: size(small);
	}

	input:-ms-input-placeholder {
		font-size: size(small);
	}

	input::-moz-placeholder {
		font-size: size(small);
	}
}

.btn-session,
.btn-shop {
	.btn__content {
		color: color(white) !important;
		font-size: size(small);
		font-weight: weight(semibold);
		text-transform: none;
	}
}

.btn-shop {
	.btn__content {
		justify-content: flex-end;
	}
}

.categories-selector-item-btn {
	.btn__content {
		flex-direction: column;
		padding: 0px;
		text-transform: none;
	}
}

.fs-16 {
	font-size: size(medium16) !important;
}

.fs-14 {
	font-size: size(medium) !important;
}

.fs-12 {
	font-size: size(caption) !important;
}

.fs-11 {
	font-size: size(small) !important;
}

.fs-13 {
	font-size: size(medium13) !important;
}

.fs-30 {
	font-size: size(large30);
}

.fs-18 {
	font-size: size(medium18) !important;
}

.fs-19 {
	font-size: size(medium19) !important;
}

.fs-28 {
	font-size: size(large28) !important;
}

.fs-17 {
	font-size: size(medium17) !important;
}

.fs-20 {
	font-size: size(large) !important;
}


.fs-17 {
	font-size: size(medium17) !important;
}

.fs-27 {
	font-size: size(large27) !important;
}

.fs-18 {
	font-size: size(medium18);
}

.store-card-btn {
	.btn__content {
		font-size: size(medium) !important;
		font-weight: weight(bold) !important;
		text-transform: none;
	}
}

.form-simulator-btn,
.banner-simulator-form-btn,
.btn-location {
	.btn__content {
		text-transform: none;
	}
}

.input-location {
	input {
		color: color(newwarning) !important;
		font-size: size(medium) !important;
		height: 48px;
	}

	input::-webkit-input-placeholder {
		color: rgba(255, 110, 28, 0.5) !important;
		font-size: size(medium) !important;
	}

	input::-moz-placeholder {
		color: rgba(255, 110, 28, 0.5) !important;
		font-size: size(medium) !important;
	}

	label {
		color: rgba(255, 110, 28, 0.5) !important;
		font-size: size(medium) !important;
		top: 8px !important;
	}

	.icon {
		color: color(newprimary) !important;
		font-size: size(large25) !important;
		justify-content: center !important;
	}

	&.input-location-primary {
		input {
			color: color(newwarning) !important;
			font-size: size(medium16) !important;
			height: 48px;
		}

		input::-webkit-input-placeholder {
			color: color(primary) !important;
			font-size: size(medium16) !important;
		}

		input::-moz-placeholder {
			color: color(primary) !important;
			font-size: size(medium16) !important;
		}

		label {
			color: color(primary) !important;
			font-size: size(medium16) !important;
			top: 8px !important;
		}

		.icon {
			color: color(primary) !important;
			font-size: size(large25) !important;
			justify-content: center !important;
		}
	}

	&.input-location-two {
		input {
			color: color(newwarning) !important;
			font-size: size(medium) !important;
			height: 50px;
		}

		input::-webkit-input-placeholder {
			color: color(primary) !important;
			font-size: size(medium) !important;
		}

		input::-moz-placeholder {
			color: color(primary) !important;
			font-size: size(medium) !important;
		}

		label {
			color: color(primary) !important;
			font-size: size(medium) !important;
			top: 8px !important;
		}

		.icon {
			color: color(primary) !important;
			font-size: size(large23) !important;
			justify-content: center !important;
		}
	}
}

.form-btn-close,
.form-btn-back {
	position: absolute !important;
	right: 0px;
	top: 0px;
	z-index: 1;
}

.form-btn-close {
	right: 0px;
}

.form-btn-back {
	left: 0px;

	span {
		font-weight: weight(medium);
		text-transform: none !important;
	}
}

.pac-container.pac-logo {
	border: 0px !important;
	border-radius: 0px !important;
	box-shadow: none !important;
	margin-left: -68px !important;
	margin-top: 10px !important;
	width: 350.5px !important;

	.pac-item {
		border-top: 1px solid #dedede;
		color: color(newwarning) !important;
		font-size: size(caption) !important;
		font-weight: weight(bold) !important;
		height: 62px !important;
		line-height: 1.2 !important;
		margin: 0px 22px !important;
		padding-top: 16px !important;

		.pac-icon {
			display: none !important;
		}

		&:first-child {
			border-top: 0px !important;
		}
	}

	.pac-item-query {
		color: color(newwarning) !important;
		display: block !important;
		font-size: size(caption) !important;
		font-weight: weight(regular) !important;

		.pac-matched {
			font-weight: weight(regular) !important;
		}
	}
}

.body-pac .pac-container {
	display: none !important;
}

.body-pac-marketplace .pac-container.pac-logo {
	border: 1px solid color(primary) !important;
	border-radius: 24px !important;
	box-shadow: none !important;
	margin-left: -52.5px !important;
	margin-top: 0px !important;
	top: 17vh !important;
	width: 288px !important;

	@media (min-width: 936px) {
		margin-left: -52.5px !important;
		top: 25.4% !important;
		width: 479px !important;
	}

	.pac-item {
		border-top: 1px solid #dedede;
		color: color(newwarning) !important;
		font-size: size(caption) !important;
		font-weight: weight(bold) !important;
		height: 62px !important;
		line-height: 1.2 !important;
		margin: 0px 22px !important;
		padding-top: 16px !important;

		.pac-icon {
			display: none !important;
		}

		&:first-child {
			border-top: 0px !important;
		}
	}

	.pac-item-query {
		color: color(newwarning) !important;
		display: block !important;
		font-size: size(caption) !important;
		font-weight: weight(regular) !important;

		.pac-matched {
			font-weight: weight(regular) !important;
		}
	}
}

.dialog {
	border-radius: 20px !important;
}

// .theme--light .list .list__tile--link:hover {
// 	background: rgba(141, 205, 208, 0.37) !important;
// }

.form-simulator {
	.input-group__selections__comma {
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.input-group--text-field__prefix {
		color: color(primary) !important;
		font-size: size(medium16) !important;
		font-weight: weight(semibold) !important;
		margin-top: 0px !important;
	}

	.app-form-component.input-group--prefix {
		&.input-group--prefix:not(.input-group--focused):not(.input-group--dirty) label {
			left: 43px !important;
		}

		&.input-group--focused {
			label {
				left: 0px;
			}	
		}
	}

	&.quinti {
		.input-group--text-field__prefix {
			color: #bcbcbc !important;
		}

		.app-input {
			border-bottom: 2px solid #bcbcbc;
		}
	}
}

.categories-scroll-active {
	.categories-selector-item-btn {
		.btn__content {
			flex-direction: row !important;
		}

		p {
			margin-left: 12px;
			max-width: min-content !important;
			max-width: -moz-min-content !important;
			text-align: left !important;

			span {
				white-space: initial !important;
			}
		}
	}
}

.dialog-market-place.dialog {
	border-radius: 0px !important;
	height: 100vh;
	margin: 0px !important;
	max-height: none !important;

	@media (min-width: 936px) {
		border-radius: 9px !important;
		height: 80vh;
	}
}

.btn-change-location,
.btn-save {
	.btn__content {
		font-size: size(small) !important;
		padding: 0px !important;
		text-transform: none !important;
	}
}

.btn-save {
	.btn__content {
		font-size: size(medium13) !important;
	}
}

.section-media {
	.title {
		display: none !important;
	}

	.button {
		opacity: 0.58 !important;
		width: 125px !important;
	}

	.loading-bar {
		display: none !important;
	}
}

.input-group--prefix:not(.input-group--focused):not(.input-group--dirty) label {
	left: 33px;
}

.app-container {
	margin: auto;
	max-width: 1200px;
	width: 100%;
}

.plans-stepper {
	background-color: transparent !important;

	&.stepper {
		background-color: transparent;
		box-shadow: none !important;
	}

	.stepper__header {
		box-shadow: none !important;
	}

	.stepper__header {
		margin: 20px auto 0 auto;
		width: 240px;
	}

	.stepper__label {
		display: none;
	}

	.stepper__step {
		padding: 0;
	}

	.stepper__step__step {
		font-size: 25px;
		font-weight: bold;
		height: 55px;
		margin-right: 0 !important;
		width: 55px;
	}

	.stepper__content {
		padding: 0 !important;
	}

	.theme--light .stepper .stepper__header .divider, .application .theme--light.stepper .stepper__header .divider {
		background-color: #ff5c00 !important;
   } 

   .theme--light .stepper .stepper__step--editable:hover, .application .theme--light.stepper .stepper__step--editable:hover {
	   background-color: transparent !important;
   }

	.stepper__step {
		background-color: transparent !important;
	}
}
 
.form-simulator-new {
	.input-group__selections__comma {
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.app-input {
		border-bottom: 2px solid #c8c8c8 !important;
	}

	.app-form-component.input-group--text-field label {
		color: #c8c8c8 !important;
	}

	.app-form-component.input-group input {
		color: #767676 !important;
	}

	.app-form-component.input-group .input-group__input .input-group__append-icon:not(:hover) {
		color: color(newprimary) !important;
	}

	.app-select {
		border-bottom: 2px solid color(newprimary);
	}

	.app-form-component.input-group.input-group--dirty .input-group__selections__comma:not(.input-group__selections__comma--active) {
		color: color(newprimary) !important;
	}

	.input-group--select {
		border-bottom: 2px solid color(newprimary);
	}

	.theme--light .icon, .application .theme--light.icon {
		color: color(newprimary) !important;
	}

	.input-group__selections {
		span {
			color: color(newprimary) !important;
		}
	}
}

.banner-plan {
	.slider-btn-right, .slider-btn-left {
		background: transparent !important;
		display: none !important;
		z-index: 0;
	}

	.slider-indicators {
		background-color:rgba(255, 255, 255, 0.69) !important;
		border-radius: 14px;
		box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.22);
		padding: 0 10px;
		z-index: 99 !important;
	}

	.slider-indicator-icon {
		background-color: color(white) !important;
		border: 1px solid color(primary);
		height: 14px;
		width: 14px;
	}

	.slider-indicator-active {
		background-color: color(primary) !important;
	}
}	

.input-component {
	&.input-group--select .input-group__selections__comma {
		color: #ff5c00 !important;
	}
}
</style>


// WEBPACK FOOTER //
// src/App.vue